import { useQuery } from '@tanstack/react-query';
import { getModerationQueue } from '../services/moderation';
import { moderationQueryKeys } from './query-keys';

export const useModerationQueueQuery = (options = {}) =>
  useQuery({
    queryKey: moderationQueryKeys.queue(),
    queryFn: async () => {
      const result = await getModerationQueue();
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch moderation queue');
      }
      return result.data;
    },
    ...options,
  });
